module.exports = __webpack_public_path__ + "static/img/yun01_6.91732c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_6.jpg
// module id = 3Wcq
// module chunks = 1